<div
  class=" h-full w-full  bg-white rounded-xl shadow-lg overflow-auto mx-auto p-6 grid grid-cols-1 md:grid-cols-5 gap-6">
  <div class="md:col-span-2 flex flex-col gap-4">

    <div class="relative rounded-2xl border-gray-chateau-100 overflow-hidden bg-white shadow-[0_4px_8px_0_#00000029]">
      @if (mainImageUrl === null || mainImageUrl === "" || mainImageUrl === undefined) {
      <img id="mainImage" [src]="'asset/imagen-no-disponible-1.jpg'" alt="Producto principal"
        class="w-full h-100 object-cover bg-white" />
      } @else {
      <img id="mainImage" [src]="mainImageUrl" alt="Producto principal" class="w-full h-100 object-cover bg-white" />
      }
    </div>

    <div class="flex gap-3 items-center">
      @for (product of images; track product.url) {
      <button
        class="w-20 h-14 rounded-lg overflow-hidden border border-gray-chateau-100  cursor-pointer hover:border-orange-400 focus:outline-none focus:ring-2 focus:ring-orange-400"
        [ngClass]="{'ring-2 ring-orange-400': product.url === mainImageUrl}" type="button"
        (click)="setMainImage(product.url)" aria-label="product.name">
        <img [src]="product?.url" alt="miniatura" class="w-full h-full object-cover" />
      </button>
      }
    </div>
  </div>

  <div class="md:col-span-3 flex flex-col gap-4">

    <div class="flex flex-col gap-2 border-b-1 border-b-gray-300">
      <div class="flex flex-row justify-between">
        <div class="flex flex-row gap-2">
          <div>
            <span class="text-orange-500">{{ product?.product?.category }}</span>
          </div>
          <div>
            <span> > </span>
          </div>
          <div>
            <span> {{ product?.product?.productType }} </span>
          </div>
        </div>
        <div (click)="close()" class="cursor-pointer">
          X
        </div>
      </div>

      <span class="text-2xl font-semibold">{{ product?.product?.name }}</span>

      <div>
        <p-tabs value="0">
          <p-tablist>
            <p-tab value="0">Descripción</p-tab>
            <p-tab value="1">Usos y Aplicaciones</p-tab>
            <p-tab value="2">Diseño</p-tab>
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel value="0">
              <p>
                {{ product?.product?.description }}
              </p>
            </p-tabpanel>
            <p-tabpanel value="1">
              <p class="m-0">
                {{ product?.product?.usesAndApplications }}
              </p>
            </p-tabpanel>
            <p-tabpanel value="2">
              <p class="m-0">
                {{ product?.product?.design }}
              </p>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </div>
    </div>

    <div class="flex flex-col gap-1">
      @if (items?.length === 0) {
      <div class="w-full rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800 flex gap-2">
        <span class="font-semibold">Sin opciones disponibles.</span>
        <span>No hay productos seleccionables en este momento.</span>
      </div>
      }
      <span class="font-medium text-xs">Dimensión</span>
      <div class="flex flex-wrap gap-2">
        @for (dimension of getDimensionsOptions; track dimension) {
        <button type="button" [title]="dimension" (click)="selectDimension(dimension)" [disabled]="readOnly" [ngClass]="{
                    'border-primary-300 text-primary-700 bg-primary-50': selectedDimension === dimension,
                    'border-secondary-75 text-gray-800 bg-white': selectedDimension !== dimension,
                    'opacity-50 cursor-not-allowed': readOnly
                    }"
          class="pb-2 pt-2 pr-4 pl-4 border rounded-2xl cursor-pointer transition-all duration-200 text-center">
          <span class="text-xs whitespace-nowrap">{{ dimension }}</span>
        </button>
        }
      </div>
    </div>

    @if (selectedDimension) {
    <div class="flex flex-col rounded-2xl border-2 gap-4 p-3 border-primary-300">
      <span class="font-semibold text-sm">Selecciona las opciones del producto</span>

      <div class="flex flex-col gap-1">
        <span class="font-medium text-xs">Espesor</span>
        <div class="flex flex-wrap gap-2">
          @for (thickness of thicknessOptions; track thickness) {
          <button type="button" [title]="thickness + ' mm'" (click)="selectThickness(thickness)" [disabled]="readOnly"
            [ngClass]="{
              'border-primary-300 text-primary-700 bg-primary-50': selectedThickness === thickness,
              'border-secondary-75 text-gray-800 bg-white': selectedThickness !== thickness,
              'opacity-50 cursor-not-allowed': readOnly
              }" class="pb-2 pt-2 pr-4 pl-4 border rounded-2xl cursor-pointer transition-all duration-200 text-center">
            <span class="text-xs whitespace-nowrap">{{ thickness }} mm</span>
          </button>

          }
        </div>
      </div>

      @if (colorsOptions && colorsOptions.length > 0) {
      <div class="flex flex-col gap-1">
        <span class="text-xs font-medium">Diseños</span>
        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          @for (productColor of colorsOptions; track productColor) {
          <button type="button" (click)="selectColor(productColor)" [disabled]="readOnly" [title]="productColor.name"
            [ngClass]="{
                    'border-primary-300 text-primary-700 bg-primary-50': selectedColor === productColor,
                    'border-secondary-75 text-gray-800 bg-white': selectedColor !== productColor,
                    'opacity-50 cursor-not-allowed': readOnly
                  }"
            class="w-20 h-14 rounded-lg overflow-hidden border border-gray-chateau-100  cursor-pointer hover:border-orange-400 focus:outline-none focus:ring-2 focus:ring-orange-400">
            <span class="text-xs">{{ productColor?.name }}</span>
          </button>
          }
        </div>
      </div>
      }

      @if (texturesOptions && texturesOptions.length > 0) {
      <div class="flex flex-col gap-1">
        <span class="text-xs font-medium">Textura</span>
        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2">
          @for (productTexture of texturesOptions; track productTexture) {
          <div class="flex flex-col gap-1">
            <button type="button" (click)="selectTexture(productTexture)" [disabled]="readOnly" [ngClass]="{
                        'border-primary-300 text-primary-700 bg-primary-50': selectedTexture === productTexture,
                        'border-secondary-75 text-gray-800 bg-white': selectedTexture !== productTexture,
                        'opacity-50 cursor-not-allowed': readOnly
                        }" class="pb-2 pt-2 pr-4 pl-4 border rounded-2xl cursor-pointer transition-all duration-200">
              <span class="text-xs">{{ productTexture }}</span>
            </button>
            <!--<button type="button" (click)="selectColor(productColor)" [ngClass]="{
                      'border-primary-300 text-primary-700 bg-primary-50': selectedColor === productColor,
                      'border-secondary-75 text-gray-800 bg-white': selectedColor !== productColor
                    }"
                              class="pb-2 pt-2 pr-4 pl-4 border rounded-2xl cursor-pointer transition-all duration-200">
                        &lt;!&ndash;<img [src]="productColor" alt="miniatura" class="w-full h-full object-cover"/>&ndash;&gt;
                      </button>
                      <span>{{ productColor }}</span>-->
          </div>
          }
        </div>
      </div>
      }

      @if (coatingOptions && coatingOptions.length > 0) {
      <div class="flex flex-col gap-1">
        <span class="font-medium text-xs">Revestimiento</span>
        <div class="flex flex-row flex-wrap gap-2">
          @for (coatingOption of coatingOptions; track coatingOption) {
          <button type="button" (click)="selectCoating(coatingOption)" [disabled]="readOnly" [ngClass]="{
              'border-primary-300 text-primary-700 bg-primary-50': selectedCoating === coatingOption,
              'border-secondary-75 text-gray-800 bg-white': selectedCoating !== coatingOption,
              'opacity-50 cursor-not-allowed': readOnly
              }" class="pb-2 pt-2 pr-4 pl-4 border rounded-2xl cursor-pointer transition-all duration-200">
            <span class="text-xs">{{ coatingOption }}</span>
          </button>

          }
        </div>
      </div>
      }

      @if (descriptionOptions && descriptionOptions.length > 0) {
      <div class="flex flex-col gap-1">
        <span class="font-medium text-xs">Descripción</span>
        <div class="flex flex-wrap gap-2">
          @for (descriptionOption of descriptionOptions; track descriptionOption) {
          <button type="button" (click)="selectDescription(descriptionOption)" [disabled]="readOnly" [title]="descriptionOption"
            [ngClass]="{
              'border-primary-300 text-primary-700 bg-primary-50': selectedDescription === descriptionOption,
              'border-secondary-75 text-gray-800 bg-white': selectedDescription !== descriptionOption,
              'opacity-50 cursor-not-allowed': readOnly
            }"
            class="max-w-full px-4 py-2 border rounded-2xl cursor-pointer transition-all duration-200 text-left">
            <span class="text-xs whitespace-normal break-words">{{ descriptionOption }}</span>
          </button>
          }
        </div>
      </div>
      }

      @if (purchasingUnityOptions && purchasingUnityOptions.length > 0) {
      <div class="flex flex-col gap-4 border-2 border-primary-300 rounded-lg p-4">
        <span class="font-semibold text-sm">Selecciona las cantidades por tarima</span>

        <div class="flex flex-col gap-1 text-xs text-gray-700 bg-primary-50 border border-primary-100 rounded-lg p-3">
          <span class="font-semibold text-sm">Equivalencias en unidades</span>
          <div class="flex flex-col sm:flex-row sm:flex-wrap gap-2">
            @if (showTarima) {<span>Tarima: {{ tarimaCantidadUnidades }} unidades</span>}
            @if (showHalfTarima) {<span>1/2 Tarima: {{ halfTarimaCantidadUnidades }} unidades</span>}
            @if (showQuarterTarima) {<span>1/4 Tarima: {{ quarterTarimaCantidadUnidades }} unidades</span>}
            @if (showMinimo) {<span>Mínimo: {{ minimoCantidadUnidades }} unidades</span>}
          </div>
        </div>

        <!-- Tabla de tarimas -->
        <div class="overflow-x-auto">
          <table class="w-full text-sm">
            <thead class="border-b-2 border-gray-300">
              <tr>
                <th class="text-left p-2">Tarima</th>
                <th class="text-center p-2">Cantidad</th>
                <th class="text-center p-2">Unidades</th>
              </tr>
            </thead>
            <tbody>
              <!-- Tarima Completa -->
              @if (showTarima) {
              <tr class="border-b border-gray-200 hover:bg-gray-50">
                <td class="p-2">
                  <span class="font-medium">Tarima</span>
                </td>
                <td class="p-2">
                  <div class="flex items-center justify-center gap-2">
                    <button (click)="decrementTarima()" class="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300">
                      -
                    </button>
                    <input [(ngModel)]="tarimaCantidad" name="tarimaCantidad" type="number" min="0" step="1"
                      (ngModelChange)="validatePositiveInteger('tarimaCantidad', $event)" (keydown)="onlyDigits($event)"
                      (paste)="onPaste($event)"
                      class="w-12 text-center border rounded px-2 py-1 disabled:bg-gray-100 appearance-none" />
                    <button (click)="incrementTarima()" class="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300">
                      +
                    </button>
                  </div>
                </td>
                <td class="p-2 text-center font-medium">
                  <span>{{ tarimaCantidad * tarimaCantidadUnidades }}</span>
                </td>
              </tr>
              }

              <!-- Media Tarima -->
              @if (showHalfTarima) {
              <tr class="border-b border-gray-200 hover:bg-gray-50">
                <td class="p-2">
                  <span class="font-medium">1/2 Tarima</span>
                </td>
                <td class="p-2">
                  <div class="flex items-center justify-center gap-2">
                    <button (click)="decrementHalfTarima()" class="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300">
                      -
                    </button>
                    <input [(ngModel)]="halfTarimaCantidad" name="halfTarimaCantidad" type="number" min="0" step="1"
                      (ngModelChange)="validatePositiveInteger('halfTarimaCantidad', $event)"
                      (keydown)="onlyDigits($event)" (paste)="onPaste($event)"
                      class="w-12 text-center border rounded px-2 py-1 disabled:bg-gray-100 appearance-none" />
                    <button (click)="incrementHalfTarima()" class="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300">
                      +
                    </button>
                  </div>
                </td>
                <td class="p-2 text-center font-medium">
                  <span>{{ halfTarimaCantidad * halfTarimaCantidadUnidades }}</span>
                </td>
              </tr>
              }

              <!-- Cuarto de Tarima -->
              @if (showQuarterTarima) {
              <tr class="border-b border-gray-200 hover:bg-gray-50">
                <td class="p-2">
                  <span class="font-medium">1/4 Tarima</span>
                </td>
                <td class="p-2">
                  <div class="flex items-center justify-center gap-2">
                    <button (click)="decrementQuarterTarima()" class="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300">
                      -
                    </button>
                    <input [(ngModel)]="quarterTarimaCantidad" name="quarterTarimaCantidad" type="number" min="0"
                      step="1" (ngModelChange)="validatePositiveInteger('quarterTarimaCantidad', $event)"
                      (keydown)="onlyDigits($event)" (paste)="onPaste($event)"
                      class="w-12 text-center border rounded px-2 py-1 disabled:bg-gray-100 appearance-none" />
                    <button (click)="incrementQuarterTarima()" class="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300">
                      +
                    </button>
                  </div>
                </td>
                <td class="p-2 text-center font-medium">
                  <span>{{ quarterTarimaCantidad * quarterTarimaCantidadUnidades }}</span>
                </td>
              </tr>
              }

              <!-- Mínimo -->
              @if (showMinimo) {
              <tr class="border-b border-gray-200 hover:bg-gray-50">
                <td class="p-2">
                  <span class="font-medium">Mínimo</span>
                </td>
                <td class="p-2">
                  <div class="flex items-center justify-center gap-2">
                    <button (click)="decrementMinimo()" class="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300">
                      -
                    </button>
                    <input [(ngModel)]="minimoCantidad" name="minimoCantidad" type="number" min="0" step="1"
                      (ngModelChange)="validatePositiveInteger('minimoCantidad', $event)" (keydown)="onlyDigits($event)"
                      (paste)="onPaste($event)"
                      class="w-12 text-center border rounded px-2 py-1 disabled:bg-gray-100 appearance-none" />
                    <button (click)="incrementMinimo()" class="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300">
                      +
                    </button>
                  </div>
                </td>
                <td class="p-2 text-center font-medium">
                  <span>{{ minimoCantidad * minimoCantidadUnidades }}</span>
                </td>
              </tr>
              }
            </tbody>
            <tfoot>
              <tr class="font-semibold bg-primary-50">
                <td class="p-2 text-left">Total unidades</td>
                <td class="p-2 text-center">-</td>
                <td class="p-2 text-center">{{ getTotalUnidades() }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      }

      <!-- Mensaje de indisponibilidad dentro del panel de opciones -->
      @if (isUnavailableBlock) {
      <div class="w-full rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800 mt-3">
        <div class="font-semibold">Producto no disponible para este cliente.</div>
        <div class="mt-1 text-amber-800">{{ unavailableMessage }}</div>
      </div>
      }
    </div>
    }

    <div class="border-b-1 border-b-gray-300"></div>

    <div class="flex justify-between items-center">
      <div class="flex flex-col gap-1">
        <span class="text-primary-300 text-3xl font-semibold">$ {{ totalPrice }}</span>
      </div>
      <div class="flex gap-2">
        <button (click)="close()"
          class="cursor-pointer rounded-3xl pt-4 pr-6 pb-4 pl-6 text-base bg-gray-chateau-500 hover:bg-gray-chateau-700 text-white">
          Cancelar
        </button>
        <button [disabled]="buttonDisable" (click)="addItemToCart()"
          class="cursor-pointer disabled:cursor-not-allowed hover:bg-primary-200 rounded-3xl pt-4 pr-6 pb-4 pl-6 text-base bg-primary-300 text-white disabled:bg-gray-50 disabled:text-gray-chateau-300">
          Agregar al pedido
        </button>
      </div>
    </div>
  </div>
</div>